module.exports = __webpack_public_path__ + "static/media/02_verwaltung.d5975e84.png";


//////////////////
// WEBPACK FOOTER
// ../assets/icons/02_verwaltung.png
// module id = 843
// module chunks = 0